import './LoaderOverlay.css';
export var loaderOverlay = '_bs5vaz0-3-8-0';
export var progressCircle = '_bs5vaz1-3-8-0';